export const openAddItemsSearchParam = 'openAddItems';
export const supplierItemSearchParam = 'supplierItemNumber';
export const customerAssortmentIdSearchParam = 'customerAssortmentId';
